<template>
    <div class="section">
      <!-- Culture -->
      <div class="g-promo-section" :style="sectionStyle">
        <div class="container g-padding-y-80--xs g-padding-y-125--sm">
          <div class="row">
            <div class="col-md-4 g-margin-t-15--xs g-margin-b-60--xs g-margin-b-0--lg">
              <p class="text-uppercase g-font-size-14--xs g-font-weight--700 g-letter-spacing--2 g-margin-b-25--xs" :class="block.options.categoryTitle.colorTheme" v-html="block.options.categoryTitle.text" ref="categoryTitle">Culture</p>
              <div class="animated fadeInLeft">
                <h2 class="g-font-size-40--xs g-font-size-50--sm g-font-size-60--md" :class="block.options.title.colorTheme" v-html="block.options.title.text" ref="title"></h2>
              </div>
            </div>
            <div class="col-md-4 col-md-offset-1">
                <p class="g-font-size-18--xs" v-html="block.options.subtitle.text" :class="block.options.subtitle.colorTheme" ref="subtitle"></p>
            </div>
          </div>
        </div>
        <div class="col-sm-3 g-promo-section__img-right--lg g-bg-position--center g-height-100-percent--md" :style="imageStyle"></div>
      </div>
      <!-- End Culture -->

      <block-settings :block="block" :order="order" @moveBlockUp="moveBlockUp" @moveBlockDown="moveBlockDown" @deleteBlock="deleteBlock" @afterUpload="afterUpload" @afterSettingsClose="afterSettingsClose"></block-settings>

    </div>
</template>

<script>
import { BlocksMixin } from "../util/mixins";

export default {
  mixins: [BlocksMixin],
  mounted() {
    this.editables = [
      this.$refs.categoryTitle,
      this.$refs.title,
      this.$refs.subtitle
    ];
  },
  computed: {
    sectionStyle() {
      return {
        backgroundColor: this.block.options.bg.color
          ? this.block.options.bg.color
          : ""
      };
    },
    imageStyle() {
      return {
        backgroundImage: this.block.options.image.url
          ? `url( ${this.block.options.image.url} )`
          : ""
      };
    }
  },
  methods: {
    deleteBlock() {
      if (this.editor1) {
        this.editor1.destroy();
      }
      this.$emit("deleteBlock");
    },
    afterUpload() {},
    afterSettingsClose() {},
    afterMove() {},
    appendCustomScript() {}
  }
};
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/blocks/BlockInfo1.vue